// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_ho","advertCardFooter__row":"c-a_hp","advertCardFooter__name":"c-a_hq","advertCardFooter__price":"c-a_hr","advertCardFooter__age":"c-a_hs"};